const pageConfig = {
  // Définir ici les pages en construction (true = en construction, false = accessible)
  underConstruction: {
    
    // Ajoutez d'autres pages selon vos besoins
  }
};

export default pageConfig;
